// exibeItem.js
class ExibeItem {
    constructor(rotulo, nomeColuna) {
      this.rotulo = rotulo;
      this.nomeColuna = nomeColuna;
    }
  }
  
  export default ExibeItem;
  